import {createResourceReducer} from 'src/shared/utils/resource';
import {
  READ_CHANNEL_LINEUP_START,
  READ_CHANNEL_LINEUP_SUCCESS,
  READ_CHANNEL_LINEUP_ERROR,
  READ_CHANNEL_LINEUP_COMPLETE,
} from './actions';

export const channelLineup = createResourceReducer({
  start: READ_CHANNEL_LINEUP_START,
  success: READ_CHANNEL_LINEUP_SUCCESS,
  error: READ_CHANNEL_LINEUP_ERROR,
  complete: READ_CHANNEL_LINEUP_COMPLETE,
});
